// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController        from "./hello_controller"
import MessageItemController  from "./message-item_controller"
import MessageFormController  from "./message-form_controller"
import ScrollChatController   from "./scroll-chat_controller"
import ChatItemController     from "./chat-item_controller"
import FileUploaderController from "./file-uploader_controller"
import ChatMainController     from "./chat-main_controller"
import ModalController        from "./modal_controller"
import CallController         from "./call_controller"
import ReportChatController   from "./report-chat_controller"
import MessageInputController from "./message-input_controller"
import PushController from "./push_controller"

application.register("hello", HelloController)
application.register("message-item", MessageItemController)
application.register("message-form", MessageFormController)
application.register("scroll-chat", ScrollChatController)
application.register("chat-item", ChatItemController)
application.register("file-uploader", FileUploaderController)
application.register("chat-main", ChatMainController)
application.register("modal", ModalController)
application.register("call", CallController)
application.register("report-chat", ReportChatController)
application.register("message-input", MessageInputController)
application.register("push", PushController)
